<template>
  <van-popup v-model="visible" class="exam-popup" get-container="body" :overlay-style="{ background: 'rgba(0, 0, 0, 0.5)' }">
    <div class="popup-title">考试数据</div>
    <div class="popup-sub">考试通过人次 {{ formatCount(statistics.examPassedOccurrenceCount) }}/{{ formatCount(statistics.examTotalOccurrenceCount) }}</div>
    <div class="popup-list">
      <div class="popup-row" v-for="item in stats" :key="item.label">
        <span>{{ item.label }}</span>
        <span :class="item.tone">{{ item.value }}<template v-if="item.value !== '-'">{{ item.unit }}</template></span>
      </div>
    </div>
    <button class="popup-btn" type="button" @click="visible = false">关闭</button>
  </van-popup>
</template>

<script>
export default {
  name: 'CampExamDataPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    statistics: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 考试通过人次、通过率、平均分和完成情况
    stats () {
      return [
        { label: '考试通过人次', value: this.formatCount(this.statistics.examPassedOccurrenceCount), unit: '人次', tone: 'green' },
        { label: '通过率', value: this.formatCount(this.statistics.examPassRate), unit: '%', tone: 'green' },
        { label: '平均分', value: this.formatCount(this.statistics.examAverageScore), unit: '分', tone: 'green' },
        { label: '考试完成人次', value: this.formatCount(this.statistics.examCompletedOccurrenceCount), unit: '人次', tone: '' },
        { label: '完成率', value: this.formatCount(this.statistics.examCompletionRate), unit: '%', tone: '' }
      ]
    },
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 空值显示为横线，单位由列表单独拼接
    formatCount (value) {
      return value === null || value === undefined || value === '' ? '-' : String(value)
    }
  }
}
</script>

<style lang="less" scoped>
.exam-popup {
  display: flex;
  flex-direction: column;
  width: 320px;
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;

  .popup-title {
    padding-top: 14px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.8);
  }

  .popup-sub {
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    color: #81766f;
  }

  .popup-list {
    padding: 8px 16px 0;
  }

  .popup-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 51px;
    border-bottom: 1px solid #f3f3f3;
    font-size: 14px;
    font-weight: 400;
    color: #564c47;

    span:last-child {
      font-weight: 500;
      color: #000;
    }

    span.green {
      color: #53ce76;
    }
  }

  .popup-btn {
    display: block;
    width: calc(~'100% - 32px');
    height: 40px;
    margin: 12px auto 16px;
    border: 0;
    border-radius: 20px;
    background: #f3f1f0;
    color: #81766f;
    font-size: 14px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampExamDataPopup.vue